import { render, staticRenderFns } from "./PaperSelect.vue?vue&type=template&id=55b78d74&scoped=true&"
import script from "./PaperSelect.vue?vue&type=script&lang=js&"
export * from "./PaperSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b78d74",
  null
  
)

export default component.exports